const _ = require('underscore');
const ProjectMap = require('../project_map/project_map');

class SingleAssetMap extends ProjectMap {
  constructor(
    assetId,
    markerColor,
    $map,
    latitude,
    longitude,
    boundsChangedCallback,
    options,
  ) {
    if (options == null) {
      options = {};
    }
    if (!latitude) {
      latitude = window.default_latitude;
    }
    if (!longitude) {
      longitude = window.default_longitude;
    }

    super(
      $map,
      boundsChangedCallback,
      options['legendValues'],
      null,
      options['kmzUrls'],
      false,
      20,
    );

    this.assetId = assetId;
    this.markerColor = markerColor;
    if (latitude && longitude) {
      this.centerLocation = { lat: latitude, lng: longitude };
    }
  }

  init() {
    this.createLockControl();
    this.setMapLock(true);

    this.setMapResizeHandler();

    return this.map.setOptions({
      panControl: false,
      styles: [
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [{ visibility: 'off' }],
        },
      ],
    });
  }

  getCenter() {
    const center = this.map.getCenter();
    return [center.lat(), center.lng()];
  }

  updateCenter() {
    if (!window.isResizing) {
      return (window.$mapCenter = this.getCenter());
    }
  }

  setMapResizeHandler() {
    window.$map = this;
    window.$mapCenter = this.getCenter();

    this.setMapIdleCallback(_.bind(this.updateCenter, this));

    return $(window).on('resize', function () {
      window.isResizing = true;
      clearTimeout(window.resizeId);
      return (window.resizeId = setTimeout(window.$map.resizeMap, 500));
    });
  }

  resizeMap() {
    const { $map } = window;
    const center = window.$mapCenter;
    $map.map.panTo({ lat: center[0], lng: center[1] });
    return (window.isResizing = false);
  }

  pinColorForAsset() {
    return this.pinColors['gray'];
  }

  addPinCrosshair() {
    const fauxMarker = this.createFauxMarker();
    if (fauxMarker) {
      return fauxMarker.appendTo(this.map.getDiv());
    }
  }

  //-----------  Private  -----------#

  setLockControlText() {
    if (this.mapLocked) {
      return this.$lockControl.text('Unlock Map');
    } else {
      return this.$lockControl.text('Lock Map');
    }
  }

  createLockControl() {
    const $controlUI = $("<div class='map-control'></div>");
    this.$lockControl = $('<div>Unlock Map</div>');
    $controlUI.append(this.$lockControl);
    $controlUI.click(() => {
      this.setMapLock(!this.mapLocked);
      return this.setLockControlText();
    });
    return this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
      $controlUI[0],
    );
  }

  createFauxMarker() {
    const $container = $("<div class='centerMarker'></div>");
    const color = this.pinColors[this.markerColor || 'red'];
    const $marker = $(
      `<svg width='32' height='50' viewBox='-12 -40 30 45'><path fill='${color}' stroke='black' stroke-width='1' d=\"${this.svgPath}\"/></svg>`,
    );
    $container.append($marker);
    return $container;
  }
}

//-----------  Export  -----------#
module.exports = SingleAssetMap;
